export default __webpack_public_path__ + "static/media/schoolAddImg5.69a262e5.png";